import { render, staticRenderFns } from "./city_word_edit.vue?vue&type=template&id=4da635dc&scoped=true&"
import script from "./city_word_edit.vue?vue&type=script&lang=js&"
export * from "./city_word_edit.vue?vue&type=script&lang=js&"
import style0 from "./city_word_edit.vue?vue&type=style&index=0&id=4da635dc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da635dc",
  null
  
)

export default component.exports